import { ArrowsOutLineVerticalIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Divider = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <ArrowsOutLineVerticalIcon size={Sizes[size]} {...rest} color={fill} />;
};

Divider.displayName = 'Divider';
